import { makeObservable, observable } from 'mobx';
import { useStores } from '../useStores';

import {
    getCurrentPlan,
    getPlanDetails,
    previewSubscription,
    createSubscription,
    upgradeSubscription,
    finalize3DSecure,
    browseConnectIntegrations,
    getConnectToken,
    cancelSubscription,
    getIntegrationDetails,
} from './actions';

export default class ConnectStore {
    env = null
    observed = {};
    /*
     * currentPlan is the publisher's active Connect subscription pulled from
     * the server. Null means pre-purchase.
     */
    currentPlan = null;
    availablePlans = [];
    chargifyActionLink = null;
    chargifyGatewayPaymentId = null;
    threeDSecureFinalized = false;
    integrations = [];
    integrationDetails = {};
    connectToken = null;

    constructor () {
        makeObservable(this, {
            observed: observable,
        });
    }

    getCurrentPlan = getCurrentPlan;
    getPlanDetails = getPlanDetails;
    previewSubscription = previewSubscription;
    createSubscription = createSubscription;
    upgradeSubscription = upgradeSubscription;
    finalize3DSecure = finalize3DSecure;
    browseConnectIntegrations = browseConnectIntegrations;
    getConnectToken = getConnectToken;
    cancelSubscription = cancelSubscription;
    getIntegrationDetails = getIntegrationDetails;
}

export function useConnectStore () {
    const { connectStore } = useStores();
    return connectStore;
}
